namespace GeniuzPOS.Member {
    export interface ReportMemberConditionRow {
        Id?: number;
        MbId?: string;
        MbType?: string;
        MbNameT?: string;
        MbNameE?: string;
        MbAddress?: string;
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
        MbZipCode?: string;
        MbLineAddr1?: string;
        MbLineAddr2?: string;
        MbLineAddr3?: string;
        MbPid?: string;
        MbTelNo?: string;
        MbEmail?: string;
        MbGender?: string;
        MbNation?: string;
        MbRace?: string;
        MbOccupation?: string;
        MbBirthDay?: string;
        MbCardType?: string;
        MbApplyDate?: string;
        MbExpireDate?: string;
        MbCardStatus?: number;
        MbPhoto?: string;
        MbAccumPoint?: number;
        MbNearlyExpirePoint?: number;
        MbExpirePointDate?: string;
        MbMemo?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullNameMb?: string;
    }

    export namespace ReportMemberConditionRow {
        export const idProperty = 'MbId';
        export const nameProperty = 'FullNameMb';
        export const localTextPrefix = 'Member.ReportMemberCondition';
        export const lookupKey = 'Member.ReportMemberCondition';

        export function getLookup(): Q.Lookup<ReportMemberConditionRow> {
            return Q.getLookup<ReportMemberConditionRow>('Member.ReportMemberCondition');
        }
        export const deletePermission = '3Member:สมาชิก:Modify';
        export const insertPermission = '3Member:สมาชิก:Modify';
        export const readPermission = '3Member:สมาชิก:View';
        export const updatePermission = '3Member:สมาชิก:Modify';

        export declare const enum Fields {
            Id = "Id",
            MbId = "MbId",
            MbType = "MbType",
            MbNameT = "MbNameT",
            MbNameE = "MbNameE",
            MbAddress = "MbAddress",
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol",
            MbZipCode = "MbZipCode",
            MbLineAddr1 = "MbLineAddr1",
            MbLineAddr2 = "MbLineAddr2",
            MbLineAddr3 = "MbLineAddr3",
            MbPid = "MbPid",
            MbTelNo = "MbTelNo",
            MbEmail = "MbEmail",
            MbGender = "MbGender",
            MbNation = "MbNation",
            MbRace = "MbRace",
            MbOccupation = "MbOccupation",
            MbBirthDay = "MbBirthDay",
            MbCardType = "MbCardType",
            MbApplyDate = "MbApplyDate",
            MbExpireDate = "MbExpireDate",
            MbCardStatus = "MbCardStatus",
            MbPhoto = "MbPhoto",
            MbAccumPoint = "MbAccumPoint",
            MbNearlyExpirePoint = "MbNearlyExpirePoint",
            MbExpirePointDate = "MbExpirePointDate",
            MbMemo = "MbMemo",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullNameMb = "FullNameMb"
        }
    }
}
